import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  PaginationTable,
  DateCell,
  RowLink,
  BOPaginationTable,
  SwitchTableVariantButtons,
  StatusCell,
} from 'common/components';
import { useToggleTableVariant } from 'common/hooks';
import { getNewTableColumns } from 'common/utils';

import { staticStyles } from './style';

const BoProptradingTable = ({ data, loading, location, history, getList, params, onRowClick }) => {
  const { tableVariant, handleSelectLegacyVariant, handleSelectNewVariant } = useToggleTableVariant({
    tableKey: 'BOProptradingTable',
  });

  const getRowLink = id => `/backoffice/proptrading/${id}`;

  /* eslint-disable */
  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
        Cell: ({
          row: {
            original: { id },
          },
        }) => (
          <RowLink link={getRowLink(id)}>
            <span>{id}</span>
          </RowLink>
        ),
      },
      {
        Header: 'User',
        accessor: 'user',
        isPreviewCell: true,
        Cell: ({
          row: {
            original: { user, id },
          },
        }) => (
          <RowLink link={getRowLink(id)} isPreviewCell>
            <span>{user}</span>
          </RowLink>
        ),
      },
      {
        Header: 'Title',
        accessor: 'title',
        Cell: ({
          row: {
            original: { title, id },
          },
        }) => <RowLink link={getRowLink(id)}>{title}</RowLink>,
      },
      {
        Header: 'Challenge',
        accessor: 'challenge',
        Cell: ({
          row: {
            original: { challenge, id },
          },
        }) => <RowLink link={getRowLink(id)}>{challenge || '-'}</RowLink>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        isPreviewCell: true,
        Cell: ({
          row: {
            original: { status, id },
          },
        }) => (
          <RowLink link={getRowLink(id)} isPreviewCell>
            <StatusCell statusCode={status} />
          </RowLink>
        ),
      },
      {
        Header: 'Account',
        accessor: 'account',
        isPreviewDescriptionCell: true,
        Cell: ({
          row: {
            original: { account, id },
          },
        }) => <RowLink link={getRowLink(id)}>{account || '-'}</RowLink>,
      },
      {
        Header: 'Withdraw account',
        accessor: 'withdraw_account__login',
        Cell: ({
          row: {
            original: { withdrawAccount, id },
          },
        }) => <RowLink link={getRowLink(id)}>{withdrawAccount || 'wallet'}</RowLink>,
      },
      {
        Header: 'Stage',
        accessor: 'stage',
        Cell: ({
          row: {
            original: { stage, id },
          },
        }) => <RowLink link={getRowLink(id)}>{stage}</RowLink>,
      },
      {
        Header: 'Created',
        accessor: 'created',
        isPreviewDescriptionCell: true,
        Cell: ({
          row: {
            original: { created, id },
          },
        }) => (
          <RowLink link={getRowLink(id)}>
            <DateCell value={created} />
          </RowLink>
        ),
      },
    ],
    []
  );
  /* eslint-enable */

  const newTableColumns = useMemo(() => getNewTableColumns(columns), [columns]);

  const gridTemplateColumns = `
    minmax(50px, 80px)
    minmax(200px, 1fr)
    minmax(120px, 1fr)
    minmax(110px, 1fr)
    minmax(120px, 1fr)
    minmax(100px, 1fr)
    minmax(100px, 1fr)
    minmax(100px, 100px)
    minmax(180px, 1fr)
  `;

  const rowProps = () => ({
    style: {
      display: 'grid',
      gridTemplateColumns,
    },
  });

  return (
    <div className="BoProptradingTable">
      <SwitchTableVariantButtons
        tableVariant={tableVariant}
        handleSelectNewVariant={handleSelectNewVariant}
        handleSelectLegacyVariant={handleSelectLegacyVariant}
      />

      {tableVariant === 'legacy' && (
        <PaginationTable
          data={data}
          loading={loading}
          columns={columns}
          onRowClick={onRowClick}
          getList={getList}
          location={location}
          history={history}
          params={params}
          getTheadTrProps={props => ({
            style: {
              display: 'grid',
              gridTemplateColumns,
            },
            ...props,
          })}
          getTrProps={rowProps}
        />
      )}

      {tableVariant === 'new' && (
        <BOPaginationTable
          tableKey="BOProptradingTable"
          data={data}
          columns={newTableColumns}
          params={params}
          getList={getList}
          loading={loading}
        />
      )}

      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

BoProptradingTable.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default BoProptradingTable;
